export const DOCUMENT_CATEGORIES = [
  { value: "medical", label: "Medical" },
  { value: "id", label: "ID" },
  { value: "contract", label: "Contract" },
  { value: "licence", label: "Licence" },
  { value: "certificate", label: "Certificate" },
  { value: "insurance", label: "Insurance" },
  { value: "service_record", label: "Service record" },
  { value: "other", label: "Other" },
];

export const documentCategoryLabel = (value) =>
  DOCUMENT_CATEGORIES.find((c) => c.value === value)?.label || "Other";

const DAY_MS = 24 * 60 * 60 * 1000;
export const EXPIRY_WARNING_DAYS = 30;

// { label, tone } for an expiry date: Valid / Expires in Nd / Expired. tone is ok | warn | bad | none.
export const documentStatus = (expiresOn, today = new Date()) => {
  if (!expiresOn) return { label: "No expiry", tone: "none" };
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  // The API sends DATE columns as local midnight in UTC ("2026-11-01T22:00:00Z" for 2 Nov in SAST), so read the local day.
  const raw = String(expiresOn);
  const at = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? new Date(`${raw}T00:00:00`) : new Date(raw);
  const days = Math.round((new Date(at.getFullYear(), at.getMonth(), at.getDate()) - start) / DAY_MS);
  if (days < 0) return { label: "Expired", tone: "bad" };
  if (days <= EXPIRY_WARNING_DAYS) return { label: days === 0 ? "Expires today" : `Expires in ${days}d`, tone: "warn" };
  return { label: "Valid", tone: "ok" };
};
